module.exports = __webpack_public_path__ + "img/left_btn.5fb3d988.png";